import React from 'react';

import styles from './Hero.module.scss';

const Hero = (props) => (
  <div className={styles.Hero}>
    <h1 className="h1">{props.title}</h1>
  </div>
)

export default Hero;



// WEBPACK FOOTER //
// ./src/components/SuccessStories/Hero/index.js